var exports = {
  "W": "x93eb46d8--25609a--dropdown",
};

module.exports = exports;
